// The Serpix `query` is just the search text (typed verbatim, operators and all).
// Target is hard-coded to google_search.

function val(row, key) {
  return (row[key] == null ? '' : String(row[key])).trim();
}

export function buildQuery(row) {
  return val(row, 'search') || val(row, 'query');
}

// A row is runnable if it has a search string.
export function hasSerpInput(row) {
  return Boolean(buildQuery(row));
}
